module.exports = __webpack_public_path__ + "static/media/anisa.9e753c1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faces/anisa.png
// module id = 1652
// module chunks = 0